class PasswordRevealInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const input = this.querySelector('input[type="password"]');
    const button = this.querySelector('button');

    button?.addEventListener('click', () => {
      if(!input) return;

      input.type = input.type === 'password' ? 'text' : 'password'; // Toggle input type
    });
  }
}

// Define the custom element
customElements.define('password-reveal-input', PasswordRevealInput);